<div class="position-relative d-inline-block w-100 image-action-card">
  <img
    [src]="imageUrl"
    [alt]="alt"
    [class]="imageClass"
    [style.max-height]="maxHeight"
    style="max-width: 100%; width: auto; height: auto;"
  />

  <div class="image-action-overlay d-flex align-items-center justify-content-center">
    <div class="d-flex flex-wrap justify-content-center gap-2 p-3">

      <button
        mat-raised-button
        color="primary"
        type="button"
        ngxClipboard
        matTooltip="Click this button to copy the image URL to your clipboard."
        [cbContent]="imageUrl"
        (click)="onCopiedURL()">
        <mat-icon>file_copy</mat-icon>
        Copy
      </button>

      <button
        mat-raised-button
        color="primary"
        type="button"
        matTooltip="Click this button to download the image."
        (click)="utils.onDownloadFromTemporaryURL(imageUrl, imageName, $event)">
        <mat-icon>download</mat-icon>
        Download
      </button>

      <button
        mat-raised-button
        color="primary"
        type="button"
        matTooltip="Click this button to view the image."
        (click)="onOpenUrl(imageUrl)">
        <mat-icon>open_in_new</mat-icon>
        View
      </button>

    </div>
  </div>
</div>
